<template>
    <luma-empty>
      <b-tabs>
       <b-tab title="E-Mail">
         <luma-user-email @saveEmail="saveEmail"
                          :username="account.username"
                          :email="account.email">
         </luma-user-email>
        </b-tab>

        <b-tab title="Passwort">
          <luma-user-password @savePassword="savePassword"></luma-user-password>
        </b-tab>
      </b-tabs>
    </luma-empty>
</template>

<script>
    import LumaEmpty from "@/layout/LumaEmpty";
    import LumaUserPassword from "./luma-user-password";
    import LumaUserEmail from "./luma-user-email";
    import {ApiRoutesModel} from "@/store/models/layout/api_routes";

    export default {
        name: "luma-account-details",
        components: {LumaUserEmail, LumaUserPassword, LumaEmpty},
        data:()=>({
        }),
        computed:{
            account(){
                return this.$currentUser
            },
            // general(){
            //     return [
            //         'first_name',
            //         'last_name',
            //         'company'
            //     ]
            // },
            // address(){
            //     return [
            //         'street',
            //         'city',
            //         'zip'
            //     ]
            // }
        },
      methods:{

        saveEmail(value){
          const params = {
            user      : this.account.username,
            email  : value
          }
          console.log(params)
          const data = {
            method:'put',
            url:'/account/users/'+this.account.username+'/update',
            params:params
          }
          const x = ApiRoutesModel.simpleAxios(data)
        },

        savePassword(value){
          const params = {
            user      : this.account.username,
            password  : value
          }
          console.log(params)
          const data = {
            method:'put',
            url:'/account/users/'+this.account.username+'/update',
            params:params
          }
          const x = ApiRoutesModel.simpleAxios(data)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/details_account/luma-account-details.vue